import PropTypes from 'prop-types';

import Modal from '#globalComponents/Overlay/Modal';
import Panel from '#globalComponents/Overlay/Panel';
import { sanitizeHtml } from '#lib/sanitize';

const EmailPreviewModal = ({ isOpen, onClose, email }) => {
	if (!email) return null;

	return (
		<Modal isOpen={isOpen} onClose={onClose} size="l">
			<Panel.Header onClose={onClose} subtitle={email.emailRecipient}>
				E-Mail-Vorschau
			</Panel.Header>
			<Panel.Body className="space-y-4">
				<div>
					<p className="text-xs font-medium text-bgBase-800 uppercase tracking-wide mb-1">Betreff</p>
					<p className="text-lg font-semibold text-text">{email.emailSubject || '(Kein Betreff)'}</p>
				</div>
				<div className="border-t border-bgBase-400 pt-4">
					<p className="text-xs font-medium text-bgBase-800 uppercase tracking-wide mb-2">Inhalt</p>
					<div
						className="rich-text-content max-w-none bg-bgBase-200 p-4 rounded-card overflow-auto max-h-96 whitespace-pre-wrap"
						dangerouslySetInnerHTML={{ __html: sanitizeHtml(email.emailContent || '') }}
					/>
				</div>
			</Panel.Body>
		</Modal>
	);
};

EmailPreviewModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	email: PropTypes.shape({
		emailRecipient: PropTypes.string,
		emailSubject: PropTypes.string,
		emailContent: PropTypes.string,
	}),
};

export default EmailPreviewModal;
